var _excluded = ["contextFactory"];
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var globalHelper = (target, _ref) => {
  var contextFactory = _ref.contextFactory,
    props = _objectWithoutProperties(_ref, _excluded);
  var _props$tag = props.tag,
    tag = _props$tag === void 0 ? 'provider' : _props$tag,
    _props$debug = props.debug,
    debug = _props$debug === void 0 ? false : _props$debug;
  var log = function log(message) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return debug && console.log("".concat(tag, ": ").concat(typeof message === 'string' ? message : ''), ...(typeof message === 'string' ? [] : [message]), ...args);
  };
  log('Creating global helper');
  var isMounted = false;
  var updateQueue = [];
  var getState = () => target.state;
  var doUpdate = (newState, after) => {
    log('doUpdate', newState);
    target.setState(newState, () => {
      after();
    });
  };
  var processQueue = () => {
    log('processQueue, length:', updateQueue.length);
    while (updateQueue.length > 0) {
      var entry = updateQueue.shift();
      if (entry) {
        var _entry = _slicedToArray(entry, 2),
          state = _entry[0],
          after = _entry[1];
        doUpdate(state, after);
      }
    }
  };
  var updateContext = function updateContext(newState) {
    var after = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};
    log('updateContext', newState);
    updateQueue.push([newState, after]);
    if (isMounted) {
      processQueue();
    }
  };
  log('returning default state');
  return {
    buildState: () => {
      log('building default state');
      var state = contextFactory(props, updateContext, getState);
      log('Built state: ', state);
      return state;
    },
    setUp: () => {
      log('setting up context, state is', getState());
      isMounted = true;
      processQueue();
    },
    tearDown: () => {
      log('tearDown');
    }
  };
};
export default globalHelper;